import React from 'react'

const Motorsports = ({ width = '24px', height = '25px', fill = '#fff' }) => {
  return (
    <svg style={{ width, height, fill }} viewBox='0 0 24 25' version='1.1'>
      <title>Motorsports</title>
      <g id='Pre-Reg-Landing-Page' stroke='none' strokeWidth='1' fillRule='evenodd'>
        <g id='Desktop-10-Copy' transform='translate(-506.000000, -527.000000)' fillRule='nonzero'>
          <g id='onboarding/sport-copy-16' transform='translate(465.000000, 503.000000)'>
            <g id='icon/16/sport/motorsports/flag' transform='translate(41.000000, 24.089286)'>
              <path
                d='M0.75,0 L0.75,24 L3,24 L3,18 L23.25,18 L23.25,0 L0.75,0 Z M7.5,15.75 L3,15.75 L3,11.25 L7.5,11.25 L7.5,15.75 Z M7.5,6.75 L3,6.75 L3,2.25 L7.5,2.25 L7.5,6.75 Z M12,11.25 L7.5,11.25 L7.5,6.75 L12,6.75 L12,11.25 Z M16.5,15.75 L12,15.75 L12,11.25 L16.5,11.25 L16.5,15.75 Z M16.5,6.75 L12,6.75 L12,2.25 L16.5,2.25 L16.5,6.75 Z M21,11.25 L16.5,11.25 L16.5,6.75 L21,6.75 L21,11.25 Z'
                id='path'
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Motorsports
